import { Box, FormControl, useTheme } from '@mui/material';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { VigoToggle } from '../vigo-toggle';
import { useEffect, useState } from 'react';
import React from 'react';
import { VigoTooltip } from '../vigo-tooltip';

interface VigoConfigToggleProps {
  formName: string;
  label: string;
  handleChange?: (newValue: boolean) => void;
  shouldDisable?: boolean;
  shouldShowTooltip?: boolean;
  tooltipText?: string;
}

export const VigoConfigToggle = ({
  formName,
  label,
  handleChange,
  shouldDisable,
  shouldShowTooltip,
  tooltipText
}: VigoConfigToggleProps) => {
  // State
  const [active, setActive] = useState<boolean>(false);

  // Hooks
  const { control } = useFormContext();
  const formVal = useWatch({ control, name: formName });
  const theme = useTheme();

  useEffect(() => {
    setActive(formVal || false);
  }, [formVal]);

  return (
    <VigoTooltip showTooltip={shouldShowTooltip} title={tooltipText ?? ''}>
      <Box
        sx={{
          border: 2,
          borderColor: active ? '#009FE3' : '#ACACAC',
          padding: { xs: '4px', sm: '6px' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          overflow: 'hidden',
          width: 182,
          ':hover': {
            backgroundColor: active ? '#009FE31A' : theme.palette.background.paper
          }
        }}>
        <FormControl fullWidth>
          <Controller
            name={formName}
            control={control}
            render={({ field: { value, onChange } }) => (
              <VigoToggle
                name={formName}
                label={label}
                checked={value || false}
                disabled={shouldDisable}
                onChange={(_event, checked) => {
                  setActive(checked);
                  onChange(checked);
                  handleChange?.(checked);
                }}
                labelSx={{
                  fontWeight: 'bold',
                  opacity: !active ? '50%' : '100%',
                  ml: 2,
                  minWidth: 0
                }}
                sx={{ flexShrink: 0 }}
                labelPlacement="start"
                formControlSx={{ width: '100%', justifyContent: 'space-between', marginLeft: 0 }}
              />
            )}
          />
        </FormControl>
      </Box>
    </VigoTooltip>
  );
};
